import type { IconPropsType } from '../../types/svg';

export function LogoutIcon({ width = '20px', height = '20px', fill = 'currentColor', tailwind }: IconPropsType) {
    return (
        <svg 
            width={width} 
            height={height} 
            viewBox="0 0 20 20" 
            fill={fill} 
            xmlns="http://www.w3.org/2000/svg" 
            className={`hover-primary ${tailwind}`}
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M5 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5.5a.75.75 0 0 1 0 1.5H5a2.5 2.5 0 0 1-2.5-2.5V3A2.5 2.5 0 0 1 5 .5h5.5a.75.75 0 0 1 0 1.5H5zm9.22 5.97a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06L15.19 11H8.75a.75.75 0 0 1 0-1.5h6.44l-.97-.97a.75.75 0 0 1 0-1.06z"
                fill={fill} 
            />
        </svg>
    );
}